<div class="video-feed">
	<div class="player-view" *ngIf="!isThermal && videoStreamService.videoSourceOne.url">
		<div class="video-window-header">
			<select [(ngModel)]="windowVideo" class="video-dropdown"
				(change)="videoStreamService.setVideoSource(0, windowVideo)">
				<option *ngFor="let v of videoStreamService.videoFeeds;let i=index" [value]="i">{{ v?.name }}
				</option>
			</select>
			<div class="video-control-bar" [class.disabled]="videoStreamService.videoSourceOne.invalidUrl">
				<img class="ctrl-icon" alt="unshare_video" (click)="unShareVideo()"
					[title]="'VIDEO_CONTROL.UNSHARE' | translate" [src]="utility.getImagePath('unshare_video.png')" />
				<img class="ctrl-icon" alt="share_video" (click)="shareVideo()" [title]="'VIDEO_CONTROL.SHARE' | translate"
					[src]="utility.getImagePath('share_video.png')" />
				<i class="fa fa-hand-pointer-o ctrl-icon" aria-hidden="true"
					(click)="controlVideo(videoStreamService.videoSourceOne)" [title]="'VIDEO_CONTROL.CONTROL' | translate"></i>
				<img class="ctrl-icon" alt="full_scrn_video" (click)="showFullScreenVideo(videoStreamService.videoSourceOne)"
					[title]="'VIDEO_CONTROL.FULL_SCREEN' | translate" [src]="utility.getImagePath('full_scrn_video.png')" />
			</div>
		</div>

		<!-- Iframe/Video player for streams -->
		<div class="iframe_container" *ngIf="!videoStreamService.videoSourceOne.invalidUrl">
			<iframe width="100%" height="100%" frameBorder="0" [src]="videoStreamService.videoSourceOne.url | safe"
				scrolling="no"></iframe>
		</div>
		<div *ngIf="videoStreamService.videoSourceOne.invalidUrl" class="invalid">{{"VIDEO_FEED.INVALID_URL" | translate}}
		</div>

	</div>

	<div *ngIf="!isThermal && !videoStreamService.videoSourceOne.url" class="no-video">
		{{"VIDEO_FEED.NO_VIDEO" | translate}}
	</div>

	<div *ngIf="isThermal" class="player-view">
		<app-thermal-feeds class="thermal-feed-box" [alarmId]="selectedAlarm?.id"></app-thermal-feeds>
	</div>

</div>